module.exports = __webpack_public_path__ + "img/gold.3cb2ef0d.svg";